import { Button } from "antd";
import { useNavigate, useParams } from "react-router";

import LockIcon from "../../assets/icons/lock.svg?react";

/**
 * Shown at `/:scope/:id/404` (and `/404`) when a section is not part of a
 * tenant's configuration.
 *
 * `FeatureFlagWrapper` redirects here whenever a route's feature flag is not
 * granted, so this page is the normal, expected outcome of correctly revoked
 * entitlements — not a failure. It therefore deliberately avoids the bug icon
 * and the "ERROR / Something went wrong / we're working to fix it" copy of
 * `ErrorPage`, which told users a working system was broken.
 */
export default function SectionNotAvailable() {
  const navigate = useNavigate();
  const { scope, id } = useParams();

  // Never `navigate(-1)` here: the previous entry is usually the gated URL that
  // redirected in, so going back would bounce straight off the flag guard again.
  // Leaving the section entirely is the only exit that terminates.
  const goBackToScope = () => {
    navigate(scope && id ? `/${scope}/${id}` : "/");
  };

  return (
    <div className="flex items-center justify-center m-5 p-8 rounded-md bg-[#FFF]">
      <LockIcon />
      <div className="w-[25%] ml-[100px]">
        <p className="text-[24px] mb-2">Section Not Available</p>
        <p className="text-[#2B4752]">
          This section is not enabled for this trial. Choose another section
          from the menu, or reach out to your administrator if you expected it
          to be available here.
        </p>
        <Button
          onClick={goBackToScope}
          variant="outlined"
          className="mt-3 w-[147px] bg-[#D2EFF9] text-[#064C68] border-[#064C68]"
        >
          Return
        </Button>
      </div>
    </div>
  );
}
